import LayoutContainer from "./Components/Layout/Layout";
import { Routes, Route } from "react-router-dom";

import Login from "./Pages/Login/Login";
import Patients from "./Pages/Patients/Patients";
import Staff from "./Pages/Staff/Staff";
import Appointments from "./Pages/Appointments/Appointments";
import PatiendProfile from "./Pages/PatientProfile/PatientProfile";
import Schedules from "./Pages/Schedules/Schedules";
import UserProfile from "./Pages/UserProfile/UserProfile";
import Leaves from "./Pages/Leaves/Leaves";
import Payments from "./Pages/Payments/Payments";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Hierarchy from "./Pages/Hierarchy/Hierarchy";
import "./App.scss";
import Settings from "./Pages/Settings/Settings";
import ActiveAccount from "./Pages/ActiveAccount/ActiveAccount";
import AllCalendar from "./Pages/Calendars/Calendars";
import WorkingPatternDetails from "./Pages/Settings/WorkingPattern/WorkingPatternDetails";
import CreateLeave from "./Pages/Settings/LeavesSettings/CreateLeave/CreateLeave";
import LocationDetails from "./Pages/Settings/LocationsSettings/LocationDetails";
import CompanyContractDetails from "./Pages/Settings/CompanyContracts/CompanyContractDetails";
import ShiftScheduler from "./Pages/Shifts/Shifts";
import Overtime from "./Pages/Overtime/Overtime";
import OvertimeDetails from "./Pages/Settings/Overtime/OvertimeDetails";
import DailyRevenueDetails from "./Pages/Settings/DailyReventuSettings/DailyRevenueDetails/DailyRevenueDetails";
import DailyRevenueSettings from "./Pages/Settings/DailyReventuSettings/DailyReventuSettings";
import Business from "./Pages/Business/Business";
import ResetPassword from "./Pages/Login/resetPassword/resetPassword";
import ExpenseMatrixPage from "./Pages/ExpensesMatrix/ExpensesMatrix";
import Finance from "./Pages/Finance/Finance";
import Support from "./Pages/Support/Support";
import Investments from "./Pages/Investments/InvestmentsComplete";
import MySubscription from "./Pages/Subscription/MySubscription";
import ClientBillingDetails from "./Pages/Admin/ClientBilling/ClientBillingDetails";
import SubscriptionsManagement from "./Pages/Admin/Subscriptions/SubscriptionsManagement";
import PlansManagement from "./Pages/Admin/Plans/PlansManagement";
import ClientInvestments from "./Pages/ClientInvestments/ClientInvestments";
import Credits from "./Pages/Credits/Credits";
import Reservations from "./Pages/Reservations/Reservations";
import ApartmentReservations from "./Pages/ApartmentReservations/ApartmentReservations";
import PublicApartments from "./Pages/PublicApartments/PublicApartments";
import PublicApartmentDetail from "./Pages/PublicApartments/PublicApartmentDetail";
import { PublicLangProvider } from "./Pages/PublicApartments/PublicLangContext";
import OnDuty from "./Pages/OnDuty/OnDuty";
import PublicReservation from "./Pages/PublicReservation/PublicReservation";
import PublicEventBooking from "./Pages/PublicEventBooking/PublicEventBooking";
import PublicMenu from "./Pages/PublicMenu/PublicMenu";
import Documents from "./Pages/Documents/Documents";
import ActivityTrail from "./Pages/ActivityTrail/ActivityTrail";
import AppOverview from "./Pages/AppOverview/AppOverview";
import Suppliers from "./Pages/Suppliers/Suppliers";
import SupplierProfile from "./Pages/SupplierProfile/SupplierProfile";
import Salaries from "./Pages/Salaries/Salaries";
import Invoices from "./Pages/Invoices/Invoices";
import OwnInvoices from "./Pages/Invoices/OwnInvoices";
import OctopusBills from "./Pages/OctopusBills/OctopusBills";
import OctopusProducts from "./Pages/OctopusProducts/OctopusProducts";
import OctopusCategories from "./Pages/OctopusCategories/OctopusCategories";
import OctopusShifts from "./Pages/OctopusShifts/OctopusShifts";

const AuthLayout = () => {
  return <div>Auth.....</div>;
};

const employees = [
  { id: 1, name: "Alice" },
  { id: 2, name: "Bob" },
];

const shifts = [
  { date: "2024-12-04", shift: "09-16", employeeId: 1 },
  { date: "2024-12-05", shift: "09-12", employeeId: 1 },
  { date: "2024-12-04", shift: "09-12", employeeId: 2 },
  { date: "2024-12-05", shift: "16-22", employeeId: 2 },
];
function App() {
  return (
    <Routes>
      <Route path="/" element={<LayoutContainer />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="patients" element={<Patients />} />
        <Route path="patients" element={<Patients />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="leaves" element={<Leaves />} />
        <Route path="patients/:id" element={<PatiendProfile />} />
        <Route path="schedules" element={<Schedules />} />
        <Route path="shifts" element={<ShiftScheduler />} />
        <Route path="payments" element={<Payments />} />
        <Route path="users" element={<Staff />} />
        <Route path="hierarchy" element={<Hierarchy />} />
        <Route path="users/:id" element={<UserProfile />} />
        <Route path="settings" element={<Settings />} />
        <Route path="overtimes" element={<Overtime />} />
        <Route path="business2" element={<Business />} />
        <Route path="business" element={<ExpenseMatrixPage />} />
        <Route path="finance" element={<Finance />} />
        <Route path="dailyRevenue" element={<DailyRevenueSettings />} />
        <Route path="investments" element={<Investments />} />
        <Route path="investments-v2" element={<ClientInvestments />} />
        <Route path="credits" element={<Credits />} />
        <Route path="reservations" element={<Reservations />} />
        <Route path="documents" element={<Documents />} />
        <Route path="activity-trail" element={<ActivityTrail />} />
        <Route path="suppliers" element={<Suppliers />} />
        <Route path="suppliers/:id" element={<SupplierProfile />} />
        <Route
          path="apartment-reservations"
          element={<ApartmentReservations />}
        />
        <Route path="on-duty" element={<OnDuty />} />
        <Route path="salaries" element={<Salaries />} />
        <Route path="invoices/efakture" element={<Invoices />} />
        <Route path="invoices/own" element={<OwnInvoices />} />
        <Route path="octopus/bills" element={<OctopusBills />} />
        <Route path="octopus/products" element={<OctopusProducts />} />
        <Route path="octopus/categories" element={<OctopusCategories />} />
        <Route path="octopus/shifts" element={<OctopusShifts />} />
        <Route path="support" element={<Support />} />
        <Route path="subscription" element={<MySubscription />} />

        {/* Admin routes */}
        <Route
          path="admin/subscriptions"
          element={<SubscriptionsManagement />}
        />
        <Route path="admin/plans" element={<PlansManagement />} />
        <Route
          path="admin/billing/:clientId"
          element={<ClientBillingDetails />}
        />

        <Route
          path="settings/working-pattern/:id"
          element={<WorkingPatternDetails />}
        />
        <Route path="settings/leaves/:id" element={<CreateLeave />} />
        <Route path="settings/overtime/:id" element={<OvertimeDetails />} />
        <Route path="settings/location/:id" element={<LocationDetails />} />
        <Route
          path="settings/company-contract/:id"
          element={<CompanyContractDetails />}
        />
        <Route
          path="settings/dailyRevenue/:id"
          element={<DailyRevenueDetails />}
        />
        <Route path="dailyRevenue/:id" element={<DailyRevenueDetails />} />
        <Route path="calendars" element={<AllCalendar />} />
        <Route element={<AuthLayout />}>
          {/* <Route path="logout" action={logoutUser} /> */}
        </Route>
      </Route>
      <Route path="overview" element={<AppOverview />} />
      <Route path="reservations/public" element={<PublicReservation />} />
      <Route path="events/public" element={<PublicEventBooking />} />
      <Route path="apartments/public" element={<PublicLangProvider><PublicApartments /></PublicLangProvider>} />
      <Route path="apartments/public/:id" element={<PublicLangProvider><PublicApartmentDetail /></PublicLangProvider>} />
      <Route path="menu/:aptId" element={<PublicLangProvider><PublicMenu /></PublicLangProvider>} />
      <Route path="activate/:token" element={<ActiveAccount />} />
      <Route path="login" element={<Login />} />
      <Route path="/reset-password" element={<ResetPassword />} />
    </Routes>
  );
}

export default App;
